const ViewDetails = ({ medicalReport, handleClick, translationMap }) => {

  return (
    <>
      <div className="common_btn_box">
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          // eslint-disable-next-line no-script-url
          href="javascript:void(0);"
          className="view_btn_link view_btn_link2"
          data-toggle="modal"
          data-target="#documentpdfmodal"
          onClick={handleClick}>
          
          {translationMap?.viewDetails}
        </a>
      </div>

    </>);

};

export default ViewDetails;